import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import LightString from '../gameobjects/LightString';
import Santa from '../gameobjects/Santa';
import Snow from '../gameobjects/Snow';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import DrawLightsInstructions from './DrawLightsInstructions';
import MathInstructions from './MathInstructions';
import FontKeys from '../FontKeys';
import GameTitleText from '../gameobjects/GameTitleText';

export default class Title extends Phaser.Scene
{
    static get KEY() { return 'Title'; }

    constructor()
    {
        super({ key: (Title).KEY });
    }

    create()
    {
        this.background = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2, UIAssetKeys._intro_background, this);

        this.smallHouse = ABCyaPhaser.Images.addImage(this.scale.width / 2 - 220, this.scale.height / 2 + 210, UIAssetKeys._small_house, this);

        this.largeHouse = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 220, this.scale.height / 2 + 150, UIAssetKeys._large_house, this);

        this.merryChristmasTitle = new GameTitleText(this, this.scale.width / 2 - 230, this.scale.height / 2 - 170, 0.75);

        // start snowfall
        new Snow(this);

        const smallHouseLightPositions = [
            { x: 171, y: 297 }, { x: 204, y: 297 }, { x: 240, y: 298 }, { x: 273, y: 301 }, { x: 316, y: 302 }, { x: 354, y: 302 },
            { x: 382, y: 301 }, { x: 415, y: 297 }, { x: 421, y: 325 }, { x: 377, y: 327 }, { x: 330, y: 325 }, { x: 288, y: 326 },
            { x: 246, y: 326 }, { x: 214, y: 326 }, { x: 188, y: 327 }, { x: 164, y: 327 }, { x: 157, y: 354 }, { x: 191, y: 356 },
            { x: 235, y: 356 }, { x: 275, y: 357 }, { x: 327, y: 357 }, { x: 362, y: 358 }, { x: 391, y: 358 }, { x: 427, y: 356 },
            { x: 437, y: 380 }, { x: 402, y: 380 }, { x: 363, y: 375 }, { x: 307, y: 380 }, { x: 266, y: 379 }, { x: 223, y: 380 },
            { x: 186, y: 383 }, { x: 148, y: 381 }, { x: 133, y: 412 }, { x: 165, y: 412 }, { x: 210, y: 413 }, { x: 257, y: 414 },
            { x: 305, y: 415 }, { x: 347, y: 412 }, { x: 385, y: 416 }, { x: 415, y: 415 }, { x: 440, y: 417 }, { x: 440, y: 448 },
            { x: 440, y: 477 }, { x: 440, y: 497 }, { x: 440, y: 529 }, { x: 413, y: 534 }, { x: 381, y: 534 }, { x: 358, y: 535 },
            { x: 323, y: 535 }, { x: 319, y: 503 }, { x: 320, y: 456 }, { x: 278, y: 453 }, { x: 276, y: 484 }, { x: 275, y: 514 },
            { x: 271, y: 536 }, { x: 237, y: 536 }, { x: 193, y: 537 }, { x: 150, y: 537 }, { x: 145, y: 503 }, { x: 145, y: 463 },
            { x: 141, y: 423 }
        ];

        const largeHouseLightPositions = [
            { x: 585, y: 231 }, { x: 634, y: 228 }, { x: 688, y: 228 }, { x: 740, y: 224 }, { x: 783, y: 224 }, { x: 826, y: 222 }, { x: 875, y: 219 }, { x: 886, y: 245 }, { x: 849, y: 245 }, { x: 803, y: 247 }, { x: 753, y: 250 }, { x: 697, y: 247 }, { x: 656, y: 247 }, { x: 615, y: 249 }, { x: 583, y: 254 }, { x: 537, y: 261 }, { x: 540, y: 284 }, { x: 584, y: 283 }, { x: 627, y: 284 }, { x: 674, y: 284 }, { x: 718, y: 283 }, { x: 756, y: 283 }, { x: 793, y: 282 }, { x: 836, y: 282 }, { x: 882, y: 280 }, { x: 925, y: 279 }, { x: 927, y: 307 }, { x: 881, y: 310 }, { x: 831, y: 313 }, { x: 789, y: 314 }, { x: 740, y: 315 }, { x: 684, y: 314 }, { x: 648, y: 314 }, { x: 606, y: 314 }, { x: 552, y: 315 }, { x: 562, y: 340 }, { x: 567, y: 391 }, { x: 571, y: 427 }, { x: 574, y: 471 }, { x: 577, y: 533 }, { x: 610, y: 533 }, { x: 648, y: 537 }, { x: 673, y: 537 }, { x: 673, y: 511 }, { x: 696, y: 493 }, { x: 714, y: 478 }, { x: 714, y: 426 }, { x: 699, y: 400 }, { x: 743, y: 380 }, { x: 794, y: 409 }, { x: 779, y: 433 }, { x: 781, y: 483 }, { x: 800, y: 500 }, { x: 821, y: 522 }, { x: 823, y: 540 }, { x: 859, y: 540 }, { x: 898, y: 538 }, { x: 903, y: 500 }, { x: 901, y: 459 }, { x: 906, y: 420 }, { x: 907, y: 376 }, { x: 910, y: 320 },
        ];

        // note: the original positions were for a widescreen game, adjust the positions for the 1024x768 game
        for (let i = 0; i < smallHouseLightPositions.length; i++)
        {
            smallHouseLightPositions[i].y += 186;
        }

        for (let i = 0; i < largeHouseLightPositions.length; i++)
        {
            largeHouseLightPositions[i].y += 186;
        }

        const lights1 = new LightString(this, smallHouseLightPositions);
        const lights2 = new LightString(this, largeHouseLightPositions);

        this.time.delayedCall(200, () =>
        {
            this.merryChristmasTitle.lights.lightSequence3();
            lights1.lightSequence2();
            lights2.lightSequence1();
        });

        this.nextButton = ABCyaPhaser.Buttons.addSimpleButton(this.scale.width / 2, this.scale.height / 2 + 246, UIAssetKeys._sprites_go_button, null, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.leaveTitle();
        }, this).setDepth(10);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 500, { scale: 1.4, offset: 100 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 200, { scale: 1, offset: 600 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
            }
        );

        this.music = ABCyaPhaser.Audio.createSound(this);
        ABCyaPhaser.Audio.playSound(SoundAssetKeys._sleigh_bells_01_loop, this.music, 1, true);

        this.santa = new Santa(this, this.scale.width / 2 + 240, this.scale.height / 2 - 64);
        this.santa.introAnimation();
    }

    leaveTitle()
    {
        this.time.removeAllEvents();
        this.tweens.killAll();

        this.music.destroy();

        if (gameData.isMathVersion)
        {
            this.scene.start(MathInstructions.KEY);
        }
        else
        {
            this.scene.start(DrawLightsInstructions.KEY);
        }
    }
}